/**
 * RÉMINISCENCE - Confetti Effects
 * 
 * Effets de confettis pour célébrer les victoires et succès.
 * Utilise canvas-confetti pour des animations de particules.
 */

import confetti from 'canvas-confetti';

/**
 * Confettis de victoire finale (grand burst)
 */
export const triggerVictoryConfetti = () => {
    confetti({
        particleCount: 150,
        spread: 80,
        origin: { y: 0.6 },
        colors: ['#D4AF37', '#FFD700', '#FFA500', '#FFFFFF'],
        startVelocity: 45,
        gravity: 1.2
    });

    // Second burst décalé
    setTimeout(() => {
        confetti({
            particleCount: 100,
            spread: 60,
            origin: { y: 0.7 },
            colors: ['#D4AF37', '#FFD700', '#FFA500'],
            startVelocity: 35
        });
    }, 250);
};

/**
 * Confettis de verdict correct (petit burst vert)
 */
export const triggerVerdictSuccess = () => {
    confetti({
        particleCount: 50,
        spread: 50,
        origin: { y: 0.7 },
        colors: ['#10B981', '#34D399', '#6EE7B7'],
        startVelocity: 25,
        gravity: 1
    });
};

/**
 * Sparkles pour fragment révélé (particules dorées)
 * @param x Position X normalisée (0-1)
 * @param y Position Y normalisée (0-1)
 */
export const triggerFragmentSparkles = (x: number, y: number) => {
    confetti({
        particleCount: 20,
        spread: 30,
        origin: { x, y },
        colors: ['#FBBF24', '#F59E0B', '#D97706'],
        startVelocity: 15,
        gravity: 0.5,
        scalar: 0.8
    });
};

/**
 * Effet de zone d'ombre (particules rouges/noires)
 * @param x Position X normalisée (0-1)
 * @param y Position Y normalisée (0-1)
 */
export const triggerShadowEffect = (x: number, y: number) => {
    confetti({
        particleCount: 15,
        spread: 25,
        origin: { x, y },
        colors: ['#DC2626', '#991B1B', '#000000'],
        startVelocity: 10,
        gravity: 0.8,
        scalar: 0.6
    });
};

/**
 * Confettis continus (pour célébrations prolongées)
 */
export const triggerContinuousConfetti = (duration: number = 3000) => {
    const end = Date.now() + duration;

    const frame = () => {
        confetti({
            particleCount: 2,
            angle: 60,
            spread: 55,
            origin: { x: 0 },
            colors: ['#D4AF37', '#FFD700']
        });

        confetti({
            particleCount: 2,
            angle: 120,
            spread: 55,
            origin: { x: 1 },
            colors: ['#D4AF37', '#FFD700']
        });

        if (Date.now() < end) {
            requestAnimationFrame(frame);
        }
    };

    frame();
};
